import { useLocation } from "react-router-dom";
import styled from "styled-components";
import React, { useState, useCallback } from "react";
import { useFeeData } from 'wagmi'
import Twitter from '@/assets/imgs/twitter.png'
import Discord from '@/assets/imgs/discord.png'
import Github from '@/assets/imgs/github.png'
import Medium from '@/assets/imgs/medium.png'


export default function Footer() {
    const { data, isError, isLoading } = useFeeData({ formatUnits: 'gwei', })

    const toTwitter = ()=>{
      window.open( 'https://twitter.com/Jungle_Fi', '_blank');
    }

    const toDiscord = ()=>{
      window.open( 'https://discord.gg/QhePXWPwX5', '_blank');
    }

    const toGithub = ()=>{
      return
    }
    const toMedium = ()=>{
      window.open( 'https://medium.com/@junglefi.io', '_blank');
    }

    return (
      <FooterWrapper>
        <div className="footer_inner flex flex--column align--center">
          <div className="gas-wrapper">
            <span className="price">${data?.formatted?.gasPrice}</span>
            <span className="desc">Gas Price</span>
          </div>
          <div className="footer_inner--social flex justify--center">
              <img onClick={toTwitter} className="twitter-img" src={Twitter} alt="" />
              <img onClick={toDiscord} className="c-img discord-img" alt="" src={Discord}/>
              <img onClick={toGithub} className="c-img github-img" alt="" src={Github}/>
              <img onClick={toMedium} className="c-img medium-img" alt="" src={Medium}/>
          </div>
        </div>
      </FooterWrapper>
    )
}

const FooterWrapper = styled.footer`
  position: relative;    
  .footer_inner{
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    .gas-wrapper{      
      width: 171px;
      line-height: 40px;
      padding: 0 7px 0 15px;
      background: rgba(255, 255, 255, 0.1);      
      margin: 0 0 30px 33px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius:6px;
      .price{
        font-weight: 600;
        font-size: 16px;
        color: #fff;
      }
      .desc{
        color: #32DE86;
      }
    }
    .footer_inner--social{
      padding-left: 39px;
      display: flex;
      justify-content: center;
      color: #fff;
      font-weight: bold;
      font-size: 16px;
      cursor: pointer;
      .twitter, .discord {
        display: flex;
        align-items: center;
        cursor: pointer;
      }
      .twitter-txt {
        padding-left: 8px;
        font-weight: 300;
      }
      .discord-txt {
        padding-left: 9px;
      }
      .discord {
        margin-left: 32px;
        font-weight: 300;
      }
      .twitter-img {
        width: 22px;
        height: 19px;
      }
      .discord-img {
        width: 26px;
        height: 19px;
      }
      .github-img{
        width: 18px;
        height: 18px;
      }
      .medium-img {
        width: 17px;
        height: 17px;
      }
      .c-img{
        margin-left:25px;
      }
    } 
    .footer_inner--copyright{
      padding-top: 16px; 
      font-weight: 300;           
    }
  }
`
